var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevicePullout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    style: {
      marginTop: 3,
      overflow: "hidden"
    },
    width: "35px",
    height: "28.43px",
    viewBox: "0 0 40 40.43",
    enableBackground: "new 0 0 40 40.43",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M26.432,14.967c0,1.256,0,2.482,0,3.747 c-0.38,0.026-0.724,0.052-1.112,0.079c-0.207,1.803,0.215,3.641-0.361,5.303c-3.065-3.063-6.128-6.124-9.133-9.129 C19.224,14.967,22.807,14.967,26.432,14.967z M12.906,17.395c0,0.205,0,0.596,0,1.012c0.388,0.028,0.731,0.054,1.163,0.086 c0,1.134-0.004,2.24,0.001,3.345c0.007,1.465,0.438,2.785,1.361,3.934c1.842,2.291,5.376,2.953,7.395,1.537 C19.505,23.99,16.161,20.649,12.906,17.395z M22.295,14.155c0.505,0,0.966,0,1.436,0c0-1.904,0-3.742,0-5.63 c-0.475,0-0.918,0-1.436,0C22.295,10.436,22.295,12.294,22.295,14.155z M16.115,8.52c-0.499,0-0.94,0-1.458,0 c0,1.499-0.004,2.953,0.002,4.407c0.003,0.868,0.56,1.334,1.456,1.227C16.115,12.282,16.115,10.409,16.115,8.52z M19.145,33.67 h1.983l-0.026-5.025h-1.937L19.145,33.67z M29.259,31.946l0.97-0.883L9.016,10.025l-0.926,0.926L29.259,31.946z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicePullout);
export default __webpack_public_path__ + "static/media/devicePullout.c0eba0f2f58380fa9dc9e17a70a50030.svg";
export { ForwardRef as ReactComponent };